
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { question, updateQuestion } from '@/actions/board';
import _ from 'lodash';
import FormCKEditor from '@/components/FormCKEditor';
import history from '@/helpers/history';
import { toast } from 'react-toastify';

function QuestionEdit() {
  const dispatch = useDispatch();
  const params = useParams();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    dispatch(question(params.question_id))
    .then(res => {
      setTitle(res.title)
      setContent(res.body)
    })
  }, []);

  const onUpdateNotice = () => {
    if(!title) {
      toast.error('제목을 입력해 주세요.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1000,
        hideProgressBar: true
      });
      return;
    } else if(!content) {
      toast.error('내용을 입력해 주세요.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1000,
        hideProgressBar: true
      });
      return;
    } 
    
    const formData = new FormData();
    formData.append("title", title);
    formData.append("body", content);
    formData.append("attachment", selectedFile); 

    dispatch(updateQuestion(params.question_id, formData))
    .then(res => {
      history.navigate(`/manager/support/qa/view/${params.question_id}`, {replace: true});
    })
  };


  return (
    <>
      {content && <section className="content pt-3">
        <div className="container new_box_s">
        <div className="box_title font_7">
          <input type="text" placeholder="제목을 입력해 주세요." onChange={e=>setTitle(e.target.value)} value={title}/>
          <div className="inner_1 font_3">
            <Link to={`/manager/support/noti/list`}>
              <button type="button" className="btn btn-success font_6">목록</button>
            </Link>
            <button type="button" className="btn btn-success font_6" style={{marginLeft: '5px'}} onClick={()=>onUpdateNotice()}>수정</button>
          </div>
        </div>        
        <div className="content">
        <FormCKEditor
          data={content}
          handleChange={setContent}
  			/>
          </div>
        </div>
        <div style={{marginTop: '10px'}}>
            <h4>첨부파일</h4>
              <input
              type="file"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
          </div>
      </section>}
    </>
  );
}

export default QuestionEdit;
